import React, { useState } from "react";
import { Link } from "react-router-dom";
import PublicShell from "@/layouts/PublicShell";
import StateBadge from "@/components/StateBadge";
import RuleBuilder from "@/components/RuleBuilder";
import { ArrowRight } from "lucide-react";

const STARTING_RULES = [
  { id: "r1", input: "weather", value: "rain", action: "show", creative: "Umbrella brand" },
  { id: "r2", input: "time", value: "morning", action: "show", creative: "Breakfast promo" },
  { id: "r3", input: "event", value: "football", action: "boost", creative: "Match-day beer" },
  { id: "r4", input: "inventory", value: "out_of_stock", action: "pause", creative: "" },
];

export default function Programmable() {
  const [rules, setRules] = useState(STARTING_RULES);
  return (
    <PublicShell>
      <section className="pt-28 md:pt-32 border-b border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 pb-14">
          <div className="flex items-center gap-3">
            <StateBadge state="EXPERIMENTAL" />
            <span className="text-[10px] uppercase tracking-[0.22em] text-white/40">
              Flagship demo · Advertising as Executable Logic
            </span>
          </div>
          <h1 className="mt-6 font-display font-black tracking-tighter leading-[0.9] text-5xl md:text-7xl">
            Advertising that
            <br />
            responds to the world.
          </h1>
          <p className="mt-6 max-w-2xl text-white/60 text-lg">
            Every real campaign in Mirrorloops now carries this same rule
            engine. Compose logic below — the simulator cycles through
            real-world conditions and shows which rule fires.
          </p>
        </div>
      </section>

      <section className="border-b border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-14" data-testid="programmable-page">
          <RuleBuilder
            rules={rules}
            onChange={setRules}
            simulator
            testidPrefix="programmable-rule"
          />
          <div className="mt-6 flex items-center gap-3">
            <Link
              to="/register"
              data-testid="programmable-cta-real"
              className="inline-flex items-center gap-2 px-5 py-3 bg-white text-black font-semibold"
            >
              Attach rules to a real campaign <ArrowRight size={14} />
            </Link>
            <Link to="/app/ads" className="text-white/60 hover:text-white text-sm">
              Already signed in? Go to Ads →
            </Link>
          </div>
        </div>
      </section>
    </PublicShell>
  );
}
